import React, { useEffect, useState } from 'react'
import Header from '../../../common/header/Header'
import Footer from '../../../common/footer/Footer'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../../config/Config'
import Loader from '../../../../loader/Loader'
import { Helmet } from 'react-helmet'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { fetchHomeData } from '../../../../redux/actions/homedataAction'

const Home_Letest_Post_Details = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const get_letest_blog_result_id = localStorage.getItem("letest_blog_result_id");
    const { slug } = useParams();
    const [letest_post_details, set_Letest_Post_Details] = useState([]);
    const { homeData, isLoading } = useSelector(
        (state) => state?.homedata || {}
    );
    // const [is_loading, set_Is_Loading] = useState(isLoading || false)

    useEffect(() => {
        dispatch(fetchHomeData());
    }, [dispatch]);

    // Scroll to the top of the page when the component is rendered
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!homeData || isLoading) return;
        const blogs = homeData?.blog || [];
        const matchedPost = blogs?.find((blog) => blog?.slug == slug);
        if (!matchedPost) {
            toast.error(`${slug} Blog not found`);
            navigate('/', { replace: true })
            return;
        }
        set_Letest_Post_Details(matchedPost)
    }, [homeData, slug])






    return (
        <div>
            {
                isLoading ? (
                    <Loader />
                ) : (
                    <>
                        <Helmet>
                            <title>{letest_post_details?.meta_title}</title>
                            <meta name="description" content={letest_post_details?.meta_description
                                || "description"} />
                            <link rel="canonical" href={`${WEB_DOMAIN_KEY}blog/${letest_post_details?.slug}`} />
                            <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}blog/${letest_post_details?.slug}`} />

                        </Helmet>
                        {/*  */}
                        <Header />
                        <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5 relative">
                            <div className=" bg-center bg-no-repeat bg-cover w-full"
                            >
                                <div className="">
                                    <div
                                        className="blog-img h-[250px] sm:h-[350px] md:h-[450px] lg:h-[600px] overflow-hidden object-fill"
                                    >
                                        <img
                                            src={`${IMG_BASE_URL}${letest_post_details?.image}`}
                                            alt={letest_post_details?.alt_image_title}
                                            className="w-full h-full object-cover object-top"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-wrap w-full">
                                <div className="w-full px-[12px]">
                                    <div className="flex flex-wrap m-0 gi-breadcrumb">
                                        <div className="w-full flex md:justify-between md:gap-3 flex-col md:flex-row">
                                            <label className=" text-[#999] hover:text-[#5caf90] inline-block font-bold mt-2">Author - <span className='font-semibold'>{letest_post_details?.author_name}</span></label>
                                            {/* <h1 className="gi-breadcrumb-title text-black block text-3xl leading-[22px] font-semibold my-[0] mx-auto capitalize max-[767px]:mb-[5px] max-[767px]:text-center">
                                                Blog Details</h1> */}
                                            <ul className="gi-breadcrumb-list mt-2 ">
                                                <li className="gi-breadcrumb-item inline-block text-[14px] font-normal tracking-[0.02rem] leading-[1.2] capitalize">
                                                    <Link to="/" className="relative text-white"><i className="fi-rr-home text-gray-700 font-semibold"></i><span className="relative text-gray-700 font-semibold
                                                    "> Home</span></Link>
                                                </li>
                                                <li className="gi-breadcrumb-item inline-block text-[14px] font-normal tracking-[0.02rem] leading-[1.2] capitalize">
                                                    <Link to="/blogs"><span className="relative text-gray-700 font-semibold">/ Blog</span></Link>
                                                </li>
                                                <li className="gi-breadcrumb-item inline-block text-[14px] font-normal tracking-[0.02rem] leading-[1.2]">
                                                    <span className="relative text-gray-700 font-semibold">/ {letest_post_details?.title}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <!-- Blog section --> */}
                        <section className="gi-blog py-[20px] max-[767px]:py-[15px]">
                            <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5 relative">

                                <div className="flex flex-wrap w-full">
                                    <div className="min-[992px]:w-[100%] w-full px-[12px]">
                                        {/* <!-- Blog content Start --> */}
                                        <div>
                                            <h1 className="text-[22px] font-bold text-[#4b5966] leading-[1.2] mb-[6px] max-[767px]:text-[20px] max-[575px]:text-[19px]">{letest_post_details?.title}</h1>
                                        </div>
                                        <div className="gi-blogs-content">
                                            <div className="gi-blogs-inner">
                                                <div className="gi-single-blog-item">
                                                    <div className="single-blog-info">
                                                        <div className="single-blog-detail">
                                                            <div className="sub__title text-[#777] text-[14px] mb-[16px]" dangerouslySetInnerHTML={{ __html: letest_post_details?.long_description }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!--Blog content End --> */}
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/*  */}
                        <Footer />
                    </>
                )
            }
        </div>
    )
}

export default Home_Letest_Post_Details